<template>
  <div class="container-down">
    <!-- 用于vava/echo -->
    <div v-if="domainNameFlag('vava', this.domain) || domainNameFlag('echo', this.domain)" class="vava-container">
      <div class="title">{{ $t('lang.down.becomeAHost') }}</div>
      <div class="phone-code flexDirection">
        <!-- vava -->
        <template v-if="domainNameFlag('vava', this.domain)">
          <img v-if="lang == 'ar'" class="logo" src="@/assets/packageAssets/views/P4_Page/Down/vava/down_bg_ar.png" alt="" />
          <img v-else class="logo" src="@/assets/packageAssets/views/P4_Page/Down/vava/down_bg.png" alt="" />
        </template>
        <!-- echo -->
        <template v-if="domainNameFlag('echo', this.domain)">
          <img v-if="lang == 'ar'" class="logo" src="@/assets/packageAssets/views/P4_Page/Down/echo/down_bg_ar.png" alt="" />
          <img v-else class="logo" src="@/assets/packageAssets/views/P4_Page/Down/echo/down_bg.png" alt="" />
        </template>
        <div class="code-box">
          <div class="code-tit">{{ $t('lang.down.invitationCode') }}</div>
          <div class="code-num">
            {{ code }}
            <img @click="copy" src="@/assets/packageAssets/views/P4_Page/Down/copy_icon.png" alt="" />
          </div>
        </div>
      </div>
      <div class="get-app">{{ $t('lang.down.getTheApp') }}</div>
      <!-- echo 展示 -->
      <template v-if="this.appNameFlag('echo', this.appName) && !this.isIOS()">
        <div class="down-btn">
          <div class="down-btn-box">
            <div class="down-logo">
              <img src="@/assets/packageAssets/packages/echo/app-logo.png" alt="" />
              <span>Echo</span>
            </div>
            <img @click="handleDownloadEcho(true)" class="down-btn-img" src="@/assets/packageAssets/views/P4_Page/Down/google_btn.png" alt="" />
          </div>
          <div class="down-btn-box">
            <div class="down-logo">
              <img src="@/assets/packageAssets/packages/echo/app-logo.png" alt="" />
              <span>Echo</span>
            </div>
            <img @click="handleDownloadEcho(false)" class="down-btn-img" src="@/assets/packageAssets/views/P4_Page/Down/app_store.png" alt="" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="down-btn">
          <div class="down-btn-box">
            <div class="down-logo">
              <img src="@/assets/packageAssets/packages/vava/app-logo.png" alt="" />
              <span>Vava</span>
            </div>
            <img @click="handleDownload('vava')" class="down-btn-img" src="@/assets/packageAssets/views/P4_Page/Down/google_btn.png" alt="" />
          </div>
          <div class="down-btn-box">
            <div class="down-logo">
              <img src="@/assets/packageAssets/packages/echo/app-logo.png" alt="" />
              <span>Echo(Vava)</span>
            </div>
            <img @click="handleDownload('echo')" class="down-btn-img" src="@/assets/packageAssets/views/P4_Page/Down/app_store.png" alt="" />
          </div>
        </div>
      </template>
      <!-- 页尾 -->
      <div class="become-tit">{{ $t('lang.down.howToBecomeAHost') }}</div>
      <div class="footer">
        <div class="footer-box">
          <div class="footer-content">
            <span>{{ $t('lang.down.tit1') }}</span>
            <template v-if="this.appNameFlag('echo', this.appName) && !this.isIOS()">
              <i>{{ $t('lang.down.tit1con3') }}</i>
            </template>
            <template v-else>
              <i>{{ $t('lang.down.tit1con1') }}</i>
            </template>
            <i>{{ $t('lang.down.tit1con2') }}</i>
          </div>
          <div class="footer-content content2">
            <span>{{ $t('lang.down.tit2') }}</span>
            <i>{{ $t('lang.down.tit2con') }}</i>
          </div>
        </div>
        <div class="footer-content">
          <span>{{ $t('lang.down.tit3') }}</span>
          <i>{{ $t('lang.down.tit3con1') }}</i>
          <i class="keynote">{{ $t('lang.down.tit3con2') }}</i>
        </div>
      </div>
    </div>

    <!-- 用于 joychat -->
    <div v-if="domainNameFlag('joychat', this.domain)" class="joychat-container">
      <div class="head">
        <img class="logo" src="@/assets/packageAssets/packages/joychat/app-logo.png" alt="" />
        <img class="imee" src="@/assets/packageAssets/views/P4_Page/Down/joychat/title.png" alt="" />
      </div>
      <div class="titie">
        {{ $t('lang.down.becomeA') }}
        <i>{{ $t('lang.down.host') }}</i>
      </div>
      <img v-if="lang == 'ar'" class="down_bg" src="@/assets/packageAssets/views/P4_Page/Down/joychat/down_bg.png" alt="" />
      <img v-else class="down_bg" src="@/assets/packageAssets/views/P4_Page/Down/joychat/down_bg_ar.png" alt="" />
      <div class="code">
        {{ $t('lang.down.inviteCode') }}:
        <i>{{ code }}</i>
        <span class="copy" @click="copy">{{ $t('lang.copy') }}</span>
      </div>
      <div class="down" @click="download">{{ $t('lang.down.tit') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let query = this.$route.query
    return {
      code: query.code,
      utmSource: 'auto_code_bind',
      channel: query.channel || '',
      appName: query.appName || '',
      domain: window.location.hostname, // 网页域名
      lang: query.lang || 'en'
    }
  },
  methods: {
    isIOS() {
      const iosAppName = ['com.fh.whisper.chat', 'com.example.echo']
      return iosAppName.includes(this.appName)
    },
    copy() {
      if (this.code) {
        this.$client.copyLink(this.code, this.$t('lang.msgCopySuccss'))
      }
    },
    // 下载页跳到 google paly 下载 （joychat）
    download() {
      let url = this.domainNameFlag('joychat', this.domain)
        ? 'https://play.google.com/store/apps/details?id=com.chat.joychat'
        : 'https://play.google.com/store/apps/details?id=com.client.goparty'
      if (this.code && this.code !== 'null') {
        let queryCode = 'utm_source=' + this.utmSource + '&utm_medium=' + this.code
        url += '&referrer=' + encodeURIComponent(queryCode)
      }
      this.$client.copyLink(this.code, this.$t('lang.msgCopySuccss'))
      window.open(url)
    },
    // 下载 vava
    handleDownload(val) {
      let url
      // vava
      if (val == 'vava') {
        url = 'https://play.google.com/store/apps/details?id=com.client.goparty'
      }
      // 非vava
      else {
        url = 'https://apps.apple.com/cn/app/echo-secret-share-virtual-link/id6479391629'
      }
      if (val == 'vava' && this.code && this.code !== 'null') {
        let queryCode = 'utm_source=' + this.utmSource + '&utm_medium=' + this.code
        url += '&referrer=' + encodeURIComponent(queryCode)
      }
      this.$client.copyLink(this.code, this.$t('lang.msgCopySuccss'))
      window.open(url)
    },
    // 下载 Echo
    handleDownloadEcho(isGoogle) {
      let url = ''
      if (isGoogle) {
        url = 'https://play.google.com/store/apps/details?id=com.chat.whisper'
      } else {
        url = 'https://apps.apple.com/cn/app/echo-secret-share-virtual-link/id6479391629'
      }
      if (isGoogle && this.code && this.code !== 'null') {
        let queryCode = 'utm_source=' + this.utmSource + '&utm_medium=' + this.code
        url += '&referrer=' + encodeURIComponent(queryCode)
      }
      this.$client.copyLink(this.code, this.$t('lang.msgCopySuccss'))
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.container-down {
  width: 100%;
  min-height: 100vh;
  background: #0c0a0d;
  padding: 16px 0 0px;

  background: url('~@/assets/packageAssets/views/P4_Page/Down/page_bg.png') no-repeat;
  background-size: cover;

  .head {
    display: flex;
    align-items: center;
    padding: 0 0 0 16px;
    .logo {
      width: 40px;
      margin-right: 12px;
    }
    .imee {
      height: 18px;
    }
  }
  .down {
    width: 118px;
    height: 40px;
    margin: 0 auto;
    background: linear-gradient(270deg, #9231f9 0%, #de2dc9 100%);
    border-radius: 8px;
    text-align: center;
    font-family: Inter-Medium, Inter;
    font-weight: 500;
    color: #ffffff;
    font-size: 16px;
    line-height: 40px;
  }
  .titie {
    width: 100%;
    height: 115px;
    font-size: 36px;
    font-family: Inter-SemiBold, Inter;
    font-weight: 600;
    color: #ffffff;
    line-height: 115px;
    text-align: center;
    > i {
      color: #df2dc9;
    }
  }
  .down_bg {
    width: 100%;
    height: auto;
  }
  .code {
    width: 100%;
    height: 20px;
    margin: 30px 0 30px 0;
    font-size: 16px;
    font-family: Inter-Regular, Inter;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
    > i {
      color: #ffe605;
    }
  }
  .copy {
    height: 22px;
    padding: 2px 5px;
    margin-left: 5px;
    line-height: 22px;
    text-align: center;
    border-radius: 11px;
    border: 1px solid #ffffff;
    font-size: 12px;
    font-family: Inter-Regular, Inter;
    font-weight: 400;
    color: #ffffff;
  }

  // vava/echo
  .vava-container {
    width: 100%;
    height: 100%;
    .title {
      width: 100%;
      margin: 20px 0 23px 0;
      font-family: Inter-Black;
      font-size: 33px;
      color: #ffffff;
      line-height: 46px;
      text-align: center;
      text-shadow: 0px 2px 4px rgba(39, 21, 126, 0.76);
    }
    .phone-code {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0 0 16px;
      .logo {
        width: 184px;
        height: 287px;
      }
      .code-box {
        .code-tit {
          font-family: Inter-Regular;
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          line-height: 25px;
        }
        .code-num {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 7px 0 20px;
          width: 155px;
          height: 60px;
          margin-top: 12px;
          background: #3e0c8c;
          border-radius: 4px;
          font-family: Inter-Regular;
          font-weight: 600;
          font-size: 20px;
          color: #ffffff;
          line-height: 60px;
          text-align: center;
          > img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .get-app {
      width: 100%;
      height: 25px;
      margin: 16px 0 16px 0;
      font-family: Inter-Regular;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      line-height: 27px;
      text-align: center;
    }
    .down-btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 16px;
      .down-btn-box {
        .down-logo {
          display: flex;
          align-items: center;
          font-family: Inter-Regular;
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 21px;
          > img {
            width: 32px;
            height: 32px;
          }
          > span {
            padding: 0 10px;
          }
        }
        .down-btn-img {
          width: 143px;
          height: 50px;
          margin-top: 12px;
        }
      }
    }
    .become-tit {
      width: 100%;
      height: 25px;
      margin: 20px 0 12px 0;
      font-family: Inter-Regular;
      font-weight: 600;
      font-size: 18px;
      color: #ffffff;
      line-height: 27px;
      text-align: center;
    }
    .footer {
      font-family: Inter-Regular;
      color: #ffffff;
      display: flex;
      justify-content: space-around;
      padding: 0 16px;
      .footer-content {
        > span {
          display: block;
          width: 148px;
          // height: 19px;
          margin-bottom: 2px;
          font-weight: 600;
          font-size: 12px;
          line-height: 20px;
        }
        > i {
          display: block;
          width: 162px;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
        }
        .keynote {
          text-decoration: underline;
        }
      }
      .content2 {
        margin-top: 10px;
      }
    }
  }
}
</style>
